// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2023 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//
/* eslint-disable spire/fenced-imports */

import { CustomAppState } from "@guestsupply/App/Store/Reducers";
import LazyImage, { LazyImageProps } from "@guestsupply/MobiusOverrides/LazyImage/LazyImage";
import useAppSelector from "@insite/client-framework/Common/Hooks/useAppSelector";
import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import setNavDrawerIsOpen from "@insite/client-framework/Store/Components/AddressDrawer/Handlers/SetNavDrawerIsOpen";
import translate from "@insite/client-framework/Translate";
import Button, { ButtonPresentationProps } from "@insite/mobius/Button";
import Typography, { TypographyProps } from "@insite/mobius/Typography";
import { HasHistory, withHistory } from "@insite/mobius/utilities/HistoryContext";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import parse from "html-react-parser";
import React, { FC } from "react";
import { useDispatch } from "react-redux";
import { hideAll } from "tippy.js";

interface MarketingSectionProps {
    image: string;
    content: string;
    detailPagePath?: string;
    title: string;
}

type Props = MarketingSectionProps & HasHistory;

export interface MarketingSectionStyle {
    wrapper?: InjectableCss;
    image?: LazyImageProps;
    titleTypography?: TypographyProps;
    contentTypography?: TypographyProps;
    imageWrapper?: InjectableCss;
    detailPagePathButton?: ButtonPresentationProps;
}

export const marketingSectionStyles: MarketingSectionStyle = {};

const styles = marketingSectionStyles;

const MarketingSection: FC<Props> = ({ image, title, content, detailPagePath, history }) => {
    const { headerHeight, isTabletScreen } = useAppSelector(state => ({
        headerHeight: (state as CustomAppState).xHeader?.headerHeight,
        isTabletScreen: (state as CustomAppState).xCommon.isTabletScreen,
    }));

    const dispatch = useDispatch();

    return (
        <StyledWrapper {...styles.wrapper} {...{ headerHeight }}>
            <StyledWrapper {...styles.imageWrapper}>
                <LazyImage
                    width="450"
                    height="215"
                    {...styles.image}
                    src={image}
                    altText={title}
                    customTransformations={{ default: "GUEST_SolNavPromo_545x365" }}
                />
            </StyledWrapper>
            {title && <Typography {...styles.titleTypography}>{parse(title)}</Typography>}
            {content && <Typography {...styles.contentTypography}>{parse(content)}</Typography>}
            {/* {detailPagePath && (
                <>
                    <Button
                        {...styles.detailPagePathButton}
                        onClick={() => {
                            history.push(detailPagePath);
                            if (isTabletScreen) {
                                dispatch(setNavDrawerIsOpen({ navDrawerIsOpen: false }));
                                setTimeout(() => dispatch(setNavDrawerIsOpen({ navDrawerIsOpen: undefined })), 300);
                            } else {
                                hideAll();
                            }
                        }}
                        aria-label="Learn More"
                    >
                        {translate("Learn More")}
                    </Button>
                </>
            )} */}
        </StyledWrapper>
    );
};

export default withHistory(MarketingSection);
